import script from "./BaseCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseCard.vue?vue&type=script&lang=ts&setup=true"

import "./BaseCard.vue?vue&type=style&index=0&id=72aecbff&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72aecbff"]])

export default __exports__